<template>
    <div class="row">
        <!-- Logo, Buscador, Otros -->
        <div class="col-12 d-flex justify-content-center">
            <div class="row mt-3 width-n">
                <div class="col-12 d-flex align-items-center p-0">
                    <!-- Logo -->
                    <inertia-link class="color-primary-n logo-header" href="/">
                        <img :src="logo" alt="Logo" width="152" height="62" v-if="logo">

                        <h1 v-else>- Logo -</h1>
                    </inertia-link>

                    <!-- Búscador -->
                    <div class="main-search">
                        <i class="fe-search main-search-icon color-primary-n" v-if="!isSearching"></i>
                        <i class="fas fa-circle-notch fa-spin main-search-icon color-secondary-n" v-else></i>

                        <div class="input-group main-search-bar mt-1">

                            <input type="text"
                                id="searchTerm"
                                class="form-control input-main-search input-primary-n dropdown-toggle"
                                placeholder="Buscar..."
                                autocomplete="off"
                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                @keyup="searchItems()"
                                @keypress.enter="searchQuery()"
                                @focus="loadLastSearches()"
                                v-model="searchTerm">

                            <div class="dropdown-menu result-search px-1" v-show="!isSearching">
                                <div class="search-no-result py-3 px-4" v-show="noSearchResult">
                                    <h5 class="m-0">No se encontraron resultados relacionados con el valor ingresado.</h5>
                                </div>

                                <div class="search-top-result pb-5" v-show="!noSearchResult && aSearchResults.length > 0">
                                    <div class="card result-search-card my-1 mx-2 cursor-pointer"
                                        v-for="(item, index) in aSearchResults" :key="index"
                                        @click="goSearchedItem(item)">
                                        <div class="card-body p-2">
                                            <img class="result-search-img"
                                                :src="item.mainImage.path" :alt="item.name">

                                            <span class="gallery-item-name fs-16 color-primary-n">{{ item.name }}</span>
                                            <span class="gallery-item-value fs-14">{{ item.price | moneyFilter }}</span>
                                        </div>
                                    </div>

                                    <div class="result-search-show-all d-flex justify-content-center">
                                        <span class="color-secondary-n cursor-pointer text-underline" @click="searchQuery()"><b>Ver todos</b></span>
                                    </div>
                                </div>

                                <div class="last-searches fs-16 py-3 px-4" v-show="searchTerm.length <= 1">
                                    <b :class="[ (aLastSearches && aLastSearches.length > 0) ? 'mr-5' : '' ]">Últimas búsquedas</b>

                                    <div class="mt-2" v-show="aLastSearches && aLastSearches.length > 0">
                                        <inertia-link class="last-searches-item mb-1 ml-2" :href="route('item.search') + '?q=' + search" v-for="(search, index) in aLastSearches" :key="index">
                                            <i class="fe-clock mr-1"></i>{{ search }}
                                        </inertia-link>
                                    </div>

                                    <div class="mt-2" v-show="!aLastSearches || aLastSearches.length == 0">
                                        <span>Aún no has relizado ninguna búsqueda.</span>
                                    </div>
                                </div>
                            </div>

                            <div class="input-group-append">
                                <button class="btn dropdown-toggle btn-primary-n fs-16 px-3 hidden-mobile h-100"
                                        type="button"
                                        data-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded="false">
                                    Categoría
                                    <i class="fe-chevron-down"></i>
                                </button>

                                <button class="mobile-cat-btn btn dropdown-toggle btn-primary-n fs-16 px-3 h-100"
                                        type="button"
                                        data-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded="false">
                                    <i class="fe-sliders" style="transform: rotate(90deg);"></i>
                                </button>

                                <div class="dropdown-menu">
                                    <inertia-link class="dropdown-item"
                                                  v-for="(category, index) in aCategories"
                                                  :key="index"
                                                  :href="route('item.category', category.id)">
                                        {{ category.name }}
                                    </inertia-link>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Opciones -->
                    <div id="header-options" class="header-options">

                        <app-header-user-c></app-header-user-c>

                        <inertia-link :href="route('shopping.cart')" class="text-decoration-none">
                            <span class="badge badge-secondary shopping-cart-badge-number bg-secondary-n">{{ getShoppingCartCount }}</span>

                            <span class="shopping-cart-icon-container flex-center-center">
                                <i class="fe-shopping-cart fs-18 color-primary-n"></i>
                            </span>
                        </inertia-link>

                    </div>

                    <div class="toggle-menu" @click="changeMobileMenuIcon()">
                        <div class="toggle-menu-icon"></div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Navbar -->
        <div class="col-12 desktop-navbar hidden-mobile">
            <div class="row mt-3">
                <div class="col-12 p-0 box-shadow-header">
                    <nav class="navbar navbar-expand-lg navbar-light bg-primary-n justify-content-center px-0 py-1">
                        <div class="width-n">
                            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
                                <span class="navbar-toggler-icon"></span>
                            </button>

                            <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
                                <ul class="navbar-nav navbar-nav-left navbar-categories">
                                    <li class="nav-item">
                                        <inertia-link class="nav-link pl-0 color-white active" id="category_0" href="/" @click="activeMenuLink(0)">
                                            <i class="fe-home fs-18"></i>&nbsp;&nbsp;Inicio
                                        </inertia-link>
                                    </li>

                                    <li class="nav-item">
                                        <a class="nav-link disabled color-white" href="#" v-if="aTopCategories.length > 0">|</a>
                                    </li>

                                    <!-- Top Categorías -->
                                    <li
                                        class="nav-item dropdown"
                                        v-for="(category, index) in aTopCategories"
                                        :key="index"
                                        :href="category.id ? route('item.category', category.id) : '#'"
                                    >
                                        <!-- Si tiene subcategorías registradas se crea la entrada al dropdown -->
                                        <a
                                            class="nav-link color-white"
                                            :class="[ category.id ? 'secondary-hover secondary-focus' : 'disabled' ]"
                                            :id="`category_${category.id}`"
                                            href="#"
                                            role="button"
                                            data-toggle="dropdown"
                                            aria-haspopup="true"
                                            aria-expanded="false"
                                            v-if="category.subcategories && category.subcategories.length > 0"
                                        >
                                            {{ category.name }}
                                        </a>

                                        <!-- Si no tiene subcategorías registradas se crea en un enlace directo a la categoría -->
                                        <inertia-link
                                            class="nav-item nav-link color-white"
                                            :id="`category_${category.id}`"
                                            :key="index"
                                            :href="category.id ? route('item.category', category.id) : '#'"
                                            :class="[ category.id ? 'secondary-hover' : 'disabled' ]"
                                            v-else
                                            @click="activeMenuLink(category.id)"
                                        >
                                            {{ category.name }}
                                        </inertia-link>

                                        <!-- Si tiene subcategorías registradas -->
                                        <div
                                            class="dropdown-menu dropdown-menu-center"
                                            v-if="category.subcategories && category.subcategories.length > 0"
                                        >
                                            <!-- Subcategorías -->
                                            <inertia-link
                                                class="dropdown-item"
                                                v-for="(subcategory, index) in category.subcategories"
                                                :key="index"
                                                :href="route('item.subcategory', subcategory.id)"
                                                @click="activeMenuLink(category.id)"
                                            >
                                                {{ subcategory.name }}
                                            </inertia-link>

                                            <!-- Ver todos -->
                                            <inertia-link
                                                class="dropdown-item"
                                                :href="route('item.category', category.id)"
                                                @click="activeMenuLink(category.id)"
                                            >
                                                Ver todas
                                            </inertia-link>
                                        </div>
                                    </li>

                                    <!-- Mega menú -->
                                    <li
                                        class="nav-item dropdown"
                                        v-if="aNonTopCategories.length > 0"
                                    >
                                        <a class="nav-link text-white secondary-hover"
                                           role="button"
                                           href="#"
                                           data-toggle="dropdown"
                                           aria-haspopup="true"
                                           aria-expanded="false">
                                            <i class="fe-grid"></i>
                                        </a>

                                        <div class="dropdown-menu dropdown-menu-center mega-menu dropdown-menu-flex py-3">

                                            <div
                                                class="dropdown-menu-flex-divider"
                                                v-for="(category, index) in aNonTopCategories"
                                                :key="index"
                                            >
                                                <inertia-link
                                                    class="dropdown-item color-primary-n"
                                                    :href="route('item.category', category.id)"
                                                >
                                                    <b>{{ category.name }}</b>
                                                </inertia-link>

                                                <inertia-link
                                                    class="dropdown-item"
                                                    v-for="(subcategory, index) in category.subcategories"
                                                    :key="index"
                                                    :href="route('item.subcategory', subcategory.id)"
                                                >
                                                    {{ subcategory.name }}
                                                </inertia-link>
                                            </div>
                                        </div>
                                    </li>
                                </ul>

                                <div class="navbar-nav ml-auto">
                                    <inertia-link href="/about-us" class="btn btn-about-us btn-secondary-n fs-16 px-2">Sobre {{ this.ecommerceName }}</inertia-link>
                                </div>
                            </div>
                        </div>
                    </nav>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

import AppHeaderUserC from '../../Shared/General/HeaderUserComponent.vue';

import filtersMixin from '../../../mixins/filtersMixin';
import fileRootPathMixin from '../../../mixins/fileRootPathMixin';
import itemMainImageMixin from '../../../mixins/itemMainImageMixin';

import { checkCatch, showMessage } from '../../../utils';

const LAST_SEARCH_TERMS_LIMIT = 5;

let searchTimeout;

export default {

    components: {

        AppHeaderUserC,

    },

    mixins: [

        filtersMixin,
        fileRootPathMixin,
        itemMainImageMixin,

    ],

    data() {

        return {

            logo: null,

            ecommerceName: '',

            aCategories: [],
            aTopCategories: [],
            aNonTopCategories: [],

            // Search
            isSearching: false,
            noSearchResult: false,
            searchTerm: '',

            aSearchResults: [],
            aLastSearches: [],

        };

    },

    computed: {

        ...mapGetters([

            'getShoppingCartCount',

        ]),

    },

    mounted() {

        this.loadHeaderData();

    },

    methods: {

        loadHeaderData() {

            this.setPageTitle();
            this.loadLogos();
            this.loadItemsCategories();

        },

        setPageTitle() {

            const companyData = $.parseJSON(localStorage.getItem('company_data'));

            if (companyData) {

                document.title = companyData.ecommerce_name;

                if (companyData.ecommerce_name.length <= 35) {

                    this.ecommerceName = companyData.ecommerce_name;

                } else {

                    this.ecommerceName = `${companyData.ecommerce_name.substring(0, 32)}...`;

                }

            }

        },

        loadLogos() {

            const logos = $.parseJSON(localStorage.getItem('logos'));

            if (logos && logos.length > 0) {

                // Logo Principal
                const logo = logos.find((l) => l.position == 1);

                if (logo) {

                    this.logo = this.fileRootPath + logo.path;

                }

                // Favicon
                const favicon = logos.find((l) => l.position == 3);

                if (favicon) {

                    $('link[rel="shortcut icon"]').attr('href', this.fileRootPath + favicon.path);

                }

            }

        },

        loadItemsCategories() {

            this.aCategories = $.parseJSON(localStorage.getItem('categories'));

            if (this.aCategories && this.aCategories.length > 0) {

                // Top
                const topCateogires = this.aCategories.slice(0, 5);

                const topCategoriesSize = topCateogires.length * 2;

                for (let i = 0; i < topCategoriesSize; i++) {

                    if (i % 2 == 1) {

                        topCateogires.splice(i, 0, { name: '|' });

                    }

                }

                this.aTopCategories = topCateogires;

                // Non Top
                if (this.aCategories.length > 5) {

                    this.aNonTopCategories = this.aCategories.slice(5, this.aCategories.length);

                    // Valido el tamaño de las categorías para ver como muevo el mega menú
                    if (!this.isMobile) {

                        this.$nextTick(() => {

                            if (this.aNonTopCategories.length <= 3) {

                                $('.dropdown-menu-flex').css('width', `${this.aNonTopCategories.length * 200}px`);

                                return;

                            }

                            const topCategoriesWidth = $('.navbar-categories').width();

                            if (topCategoriesWidth >= 660) {

                                const offset = 675 - topCategoriesWidth;

                                $('.mega-menu').attr('style', `left: ${offset}px !important`);

                            }

                        });

                    }

                }

            }

        },

        searchItems() {

            this.isSearching = true;
            this.noSearchResult = false;
            this.aSearchResults = [];

            if (searchTimeout) {

                clearTimeout(searchTimeout);

            }

            searchTimeout = setTimeout(() => {

                if (this.searchTerm.length > 1) {

                    axios
                        .get(`/inventory/items/search/${this.searchTerm}`)
                        .then((response) => {

                            const { data } = response;

                            if (!data.success) {

                                showMessage('error', 'Atención', data.message);
                                return;

                            }

                            if (this.isMobile) {

                                this.searchQuery();

                                return;

                            }

                            $('#searchTerm').dropdown('show');

                            if (data.data.length == 0) {

                                this.noSearchResult = true;

                            } else {

                                this.aSearchResults = data.data.map((item) => {

                                    item.mainImage = this.getItemMainImage(item);

                                    return item;

                                });

                            }

                            this.isSearching = false;

                        })
                        .catch((error) => {

                            checkCatch(error);

                        });

                } else {

                    this.isSearching = false;

                    this.loadLastSearches();

                }

            }, 400);

        },

        searchQuery() {

            if (this.searchTerm.length > 1) {

                this.saveLastSearch();

                $('#searchTerm').blur();
                $('#searchTerm').dropdown('hide');

                this.isSearching = false;

                this.$inertia.visit(`${this.route('item.search')}?q=${this.searchTerm}`);

            }

        },

        goSearchedItem(item) {

            this.saveLastSearch();

            this.$inertia.visit(this.route('item.detail', item.id));

        },

        saveLastSearch() {

            if (this.searchTerm.length > 1) {

                let aLastSearches = JSON.parse(localStorage.getItem('last_searches'));

                if (!aLastSearches) {

                    aLastSearches = [this.searchTerm];

                } else if (!aLastSearches.includes(this.searchTerm)) {

                    aLastSearches.unshift(this.searchTerm);

                }

                localStorage.setItem('last_searches', JSON.stringify(aLastSearches.slice(0, LAST_SEARCH_TERMS_LIMIT)));

            }

        },

        loadLastSearches() {

            if (this.searchTerm.length <= 1) {

                this.aLastSearches = JSON.parse(localStorage.getItem('last_searches'));

            } else if (this.aSearchResults.length > 0) {

                this.aLastSearches = [];

            }

        },

        changeMobileMenuIcon() {

            $('.toggle-menu').toggleClass('open');

        },

        activeMenuLink(categoryId) {

            $('.navbar-nav-left a').removeClass('active');
            $(`#category_${categoryId}`).addClass('active');

        },

    },

};
</script>
